import React, { useState } from 'react';
import { Button, Paper } from '@material-ui/core';

import OrganizationChip from 'components/OrganizationChip';
import { mediumGray } from 'utils/color-styles';

import { CommunityFull } from '../types';
import { communityBannerHeight } from '../Banner';
import { composeTypeText } from '../utils';

import { PartnersModal } from './PartnersModal';
import { Lead } from './Lead';
import { LeadsModal } from './LeadsModal';

// @NOTE-DP: extract to MUI theme once we have proper styleguide in place
const SubHeader = ({ children }: { children: React.ReactNode }): JSX.Element => (
  <h3 style={{ fontWeight: 500, fontSize: 16 }}>{children}</h3>
);

const Partners = ({ community }: { community: CommunityFull }): JSX.Element | null => {
  const [showModal, setShowModal] = useState(false);

  const maxLeadsPreviewCount =
    3 + (community.Nonprofits?.length < 4 ? 2 - community.Nonprofits?.length / 2 : 0);
  const renderedCommunityLeadsLength = community.leads.slice(0, maxLeadsPreviewCount).length;
  const maxPartnersPreviewCount = 14 - renderedCommunityLeadsLength * 2;

  if (!community.Nonprofits?.length) {
    return null;
  }
  return (
    <div
      style={{
        overflowY: 'hidden',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <SubHeader>Partner Organizations ({community.Nonprofits.length})</SubHeader>
        {community.Nonprofits.length > maxPartnersPreviewCount && (
          <Button variant="text" onClick={() => setShowModal(true)}>
            View All
          </Button>
        )}
      </div>
      {community.Nonprofits.slice(0, maxPartnersPreviewCount).map((nonprofit) => (
        <OrganizationChip organization={nonprofit} key={nonprofit.id} />
      ))}
      {showModal && (
        <PartnersModal partners={community.Nonprofits} onClickClose={() => setShowModal(false)} />
      )}
    </div>
  );
};

const CommunityLeads = ({ community }: { community: CommunityFull }): JSX.Element | null => {
  const [showModal, setShowModal] = useState(false);
  const maxLeadsPreviewCount =
    3 + (community.Nonprofits?.length < 4 ? 2 - community.Nonprofits?.length / 2 : 0);
  const renderedCommunityLeads = community.leads.slice(0, maxLeadsPreviewCount);

  if (!community.leads.length) {
    return null;
  }
  return (
    <>
      <div
        style={{
          margin: '0 -32px',
          width: 'calc(100% + 64px)',
        }}
      >
        <div
          style={{
            margin: '0 32px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <SubHeader>
            {composeTypeText(community.type)} Leads ({community.leads.length})
          </SubHeader>
          {community.leads.length > maxLeadsPreviewCount && (
            <Button variant="text" onClick={() => setShowModal(true)}>
              View All
            </Button>
          )}
        </div>
        {renderedCommunityLeads.map((lead, i) => (
          <div
            key={lead.User.id}
            style={
              i + 1 === renderedCommunityLeads.length
                ? {}
                : {
                    borderBottom: `1px solid ${mediumGray}`,
                  }
            }
          >
            <Lead lead={lead} />
          </div>
        ))}
      </div>
      {showModal && <LeadsModal leads={community.leads} onClickClose={() => setShowModal(false)} />}
    </>
  );
};

export const CommunityInfo = ({ community }: { community: CommunityFull }): JSX.Element => (
  <Paper>
    <div
      style={{
        padding: '10px 20px',
        overflow: 'hidden',
        height: communityBannerHeight,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Partners community={community} />
      <CommunityLeads community={community} />
    </div>
  </Paper>
);
